const medicalConditionName = {
  acuteRespiratory:
    'Acute respiratory (e.g. COVID-19, pneumonia, influenza, or other viral infection or illness)',
  altitudeSickness: 'Altitude sickness',
  arthritisOrRheumatologicalIllness:
    'Arthritis or rheumatological illness (e.g. lupus, tendonitis, gout, knee or hip replacement)',
  asthma: 'Asthma',
  autoimmuneIllness: 'Autoimmune illness (e.g. related to immunology.)',
  cancer:
    'Cancer (e.g. breast cancer, kidney cancer, leukemia, liver cancer, melanoma, non-Hodgkins lymphoma, or skin cancer)',
  cardiovascularDisease:
    'Cardiovascular disease (e.g. angina, arrhythmia, atrial fibrillation, cardiomyopathy, heart attacks, heart disease, heart failure, heart valve conditions, high blood pressure, high cholesterol, or pacemakers)',
  chronicLungConditions: 'Chronic lung conditions (e.g. emphysema)',
  diabetes: 'Diabetes',
  earEyeNoseOrThroatIllness:
    'Ear, eye, nose or throat illness (e.g. ear infections, eye or sinus problems)',
  gastrointestinalDisease: "Gastrointestinal disease (e.g. Crohn's disease or ulcerative colitis)",
  gastrointestinalIllness:
    'Gastrointestinal illness (e.g. Bali belly, diarrhoea, food poisoning, gastroenteritis, nausea, stomach cramps, or vomiting)',
  kidneyOrUrinaryConditions:
    'Kidney or urinary conditions (e.g. dialysis, kidney impairment or failure, prostate conditions, renal conditions or urinary tract infections)',
  mentalHealthConditions:
    'Mental health conditions (e.g. anxiety, bipolar disorder, depression, emotional distress, long term or recurring mental health conditions, panic attacks or stress)',
  muscularSkeletalConditions:
    'Muscular skeletal conditions (e.g. back or disc problems, osteoporosis, or sciatica)',
  neurologicalConditions:
    'Neurological conditions (e.g. epilepsy, motor neuron disease, Parkinsons disease, or seizures)',
  pregnancy: 'Pregnancy',
  rheumatology: 'Rheumatology',
  stroke: 'Stroke (including mini stroke)',
  other: 'Other',
} as const;

export { medicalConditionName };
